import { getRuntimeMode } from "@/ts/runtime-info"
import type { ExternalLinkRequest, ExternalLinkResult, ExternalLinkService } from "@/interface/DTO_Interfaces"

export const isExternalUrl = (url: string): boolean => /^https?:\/\//i.test(url)

export const createExternalLinkService = (): ExternalLinkService => ({
        open: async (request: ExternalLinkRequest): Promise<ExternalLinkResult> => {
                const mode = getRuntimeMode()

                if (!isExternalUrl(request.url)) {
                        return {
                                ok: false,
                                url: request.url,
                                mode,
                                reason: "Only absolute HTTP(S) links are allowed.",
                        }
                }

                if (mode === "native-shell") {
                        try {
                                const { openUrl } = await import("@tauri-apps/plugin-opener")
                                await openUrl(request.url)

                                return { ok: true, url: request.url, mode }
                        } catch (error) {
                                return {
                                        ok: false,
                                        url: request.url,
                                        mode,
                                        reason: error instanceof Error ? error.message : String(error),
                                }
                        }
                }

                if (typeof window === "undefined" || typeof window.open !== "function") {
                        return {
                                ok: false,
                                url: request.url,
                                mode,
                                reason: "No window context available.",
                        }
                }

                const popup = window.open(request.url, request.target ?? "_blank", "noopener,noreferrer")

                return {
                        ok: popup !== null,
                        url: request.url,
                        mode,
                        reason: popup === null ? "Popup blocker prevented opening the external link." : undefined,
                }
        },
})
